<template>
    <b-sidebar
        id="cat-form-sidebar"
        :visible="isCatFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(categoryData)"
        @hidden="resetForm(resetData)"
        @change="(val) => $emit('update:is-cat-form-sidebar-active', val)"
    >
        <template #default="{ hide }"> 
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
            <h5 class="mb-0">
            Service Category Form
            </h5>
            <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="hide"
            />
        </div>
        <validation-observer
            v-slot="{ validate }"
            ref="formObserver"
        >
            <b-form
            class="p-2"
            @submit.prevent="onSubmit(true)"
            @reset.prevent="resetForm"
            >
            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">
                <validation-provider
                    v-slot="{errors, validate}"
                    :name="'title_'+lang.code"
                    rules="min:0"
                >
                    <b-form-group
                    label="Title"
                    :label-for="'title_'+lang.code"
                    >
                    <b-form-input
                        :id="'title_'+lang.code"
                        v-model="Data.title[lang.code]"
                        autofocus
                        :state="errors[0] ? false : null"
                        trim
                        :placeholder="'Title ('+lang.code+')'"
                        @input="(value) => { validate(); changeTitle(lang.code, value); }"
                    />
                    <b-form-invalid-feedback>
                        {{ errors[0] }}
                    </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                <validation-provider
                    v-slot="{errors, validate}"
                    :name="'slug' + lang.code"
                    rules="required"
                >
                    <b-form-group
                    label="Slug"
                    :label-for="'slug' + lang.code"
                    >
                    <b-form-input
                        :id="'slug' + lang.code"
                        v-model="Data.slug[lang.code]"
                        autofocus
                        :state="errors[0] ? false : null"
                        trim
                        :placeholder="'Slug (' + lang.code + ')'"
                        @input="validate"
                    />
                    <b-form-invalid-feedback>
                        {{ errors[0] }}
                    </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                </b-tab>
            </b-tabs>
            <validation-provider
                #default="validationContext"
                name="IsActive"
                rules="min:0"
            >
                <b-form-group
                label="Is Active"
                label-for="IsActive"
                >
                <b-form-checkbox
                    id="isactive"
                    checked="true"
                    class="custom-control-success"
                    v-model="Data.is_active"
                    switch
                />
                <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>
                <div class="d-flex mt-2">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-2"
                        type="submit"
                    >
                        Submit
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        type="button"
                        variant="outline-secondary"
                        @click="hide"
                    >
                        Cancel
                    </b-button>
                </div>
            </b-form>
        </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs,BTab
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref,onUnmounted } from '@vue/composition-api'
import { required, alphaNum, email, password,confirmed } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import { slugify } from '@/@fake-db/utils'
import languagesStoreModule from '@/views/languages/languagesStoreModule'

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
        vSelect, BTabs, BTab, ValidationProvider, ValidationObserver,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isCatFormSidebarActive',
        event: 'update:is-cat-form-sidebar-active',
    },
    props: {
        isCatFormSidebarActive: {
        type: Boolean,
        required: true,
        },
        categoryData: {
        type: Object,
        required: false,
        },
    },
    setup(props, { emit }) {
        const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)

        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
        });

        const toast = useToast()
        const langs = ref([]);
        const catData = ref([]);
        const userStorage = JSON.parse(localStorage.getItem('userData'));
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        const blankData = {
            created_by: userStorage.id,
            title: {},
            slug: {},
            is_active:true,
            parent:0,
            ordering_count:0,
            sites_id: getLocalSite.id
        }
        const Data = ref(JSON.parse(JSON.stringify(blankData)))
        const formObserver = ref(null);

        const resetData = () => {
            Data.value = JSON.parse(JSON.stringify(blankData))
        }

        const getData = (data) => {
            if(data){
                data.is_active = data.is_active?true:false;
                Data.value  = JSON.parse(JSON.stringify(data));
            }else{
                Data.value = JSON.parse(JSON.stringify(blankData))
            }
        }

        const getLangs = (fil) => {
            store.dispatch('app-languages/fetchData', fil)
                .then((res) => {
                if(res.data.success){
                    langs.value = res.data.data;
                }    
            });
        }

        let filter = {
            is_active:1,
        }

        getLangs(filter);

        const onSubmit = async () => {
            if (formObserver.value) {
                const isValid = await formObserver.value.validate();

                if (!isValid) {
                    const errorMessages = Object.entries(formObserver.value.errors)
                        .filter(([key, message]) => message.length)
                        .map(([key, message]) => `${message}`)

                    toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                        title: `Error`,
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: `${errorMessages.join(" , ")}`,
                        },
                    });

                    return
                }
            }

            if(Data.value.id){
                try {
                    const res = await store.dispatch('app-service/updateCategory', Data.value);

                    if (res?.data?.success) {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message || 'Category updated successfully!',
                            },
                        });

                        emit('refetch-data');
                        emit('update:is-cat-form-sidebar-active', false);
                    } else {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Error',
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: res?.data?.message || 'Failed to update category.',
                            },
                        });
                    }
                } catch (err) {
                    toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Network Error',
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: err?.response?.data?.message || 'Something went wrong while updating the category.',
                        },
                    });
                }
            } else {
                try {
                    const res = await store.dispatch('app-service/addCategory', Data.value);

                    if (res?.data?.success) {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message || 'Category added successfully!',
                            },
                        });

                        emit('refetch-data');
                        emit('update:is-cat-form-sidebar-active', false);
                    } else {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Error',
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: res?.data?.message || 'Failed to add category.',
                            },
                        });
                    }

                } catch (err) {
                    toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Network Error',
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: err?.response?.data?.message || 'Something went wrong while adding the category.',
                        },
                    });
                }
            }
        }

        const changeTitle  = (langCode, value) => {
            Data.value.slug[langCode] =  slugify(value)
        }

        const resetForm = () => {
            Data.value = blankData
        }

        const {
            refFormObserver,
            getValidationState,
        } = formValidation(resetData)

        return {
            Data,
            onSubmit,
            catData,
            refFormObserver,
            getValidationState,
            resetForm,
            resetData,
            getData,
            changeTitle,
            langs,
            formObserver
        }
    } 
}
</script>